import { cn } from "@/lib/utils";
import { useUser } from "@/providers/user";
import { NotificationType } from "@/types/user/notification";
import { useDebounce } from "@/utils/misc";
import { ActionWrapper } from "@/utils/wretch";
import { Check, CircleX, Loader2 } from "lucide-react";
import { useEffect, useState } from "react";
import { useFetcher, useSearchParams } from "react-router-dom";
import { Button } from "../ui/button";
import { SimpleTooltip } from "../ui/simple-tooltip";
import { Skeleton } from "../ui/skeleton";
import { NotificationIcon } from "./item";

export function FromNotification() {
    const [searchParams] = useSearchParams();
    const [open, setOpen] = useState(false);
    const debouncedOpen = useDebounce(open, 200, value => value == false);
    const { mark_notification_as_seen } = useUser();
    const fetcher = useFetcher<ActionWrapper<NotificationType>>();

    useEffect(() => {
        if (searchParams.get("from_notification")) {
            setOpen(true);
            fetcher.load(`/notifications/${searchParams.get("from_notification")}`);
        }
    }, [searchParams]);

    if (!debouncedOpen) return null;

    if (!searchParams.has("from_notification")) return null;

    if (fetcher.state == "idle" && !fetcher.data?.success) return null;

    return fetcher.data?.success ? (
        <div className={cn("fixed right-[10px] top-[75px] z-10 transition-all duration-200", open ? "opacity-100" : "opacity-0")}>
            <div className="rounded-xl border bg-card p-4 text-card-foreground shadow">
                <CircleX className="absolute right-2 top-2 size-4 cursor-pointer text-gray-500 transition-all duration-300 hover:text-gray-700" onClick={() => setOpen(false)} />
                <div className="flex space-x-3">
                    {fetcher.state == "idle" ? <NotificationIcon notification={fetcher.data.content} className="size-5" /> : <Loader2 className="size-5 animate-spin" />}
                    <div>
                        {fetcher.state == "idle" ? (
                            <div className="flex space-x-2">
                                <div>
                                    {fetcher.data.content.title && <p className="text-sm font-bold">{fetcher.data.content.title}</p>}
                                    {fetcher.data.content.content && <p className={cn("text-xs", "whitespace-pre-line")}>{fetcher.data.content.content}</p>}
                                </div>
                                {!fetcher.data.content.seen && (
                                    <SimpleTooltip message="Marquer comme lu">
                                        <Button
                                            size="icon"
                                            variant="ghost"
                                            onClick={() => {
                                                if (fetcher.data?.content?.id) {
                                                    mark_notification_as_seen(fetcher.data.content.id);
                                                    setOpen(false);
                                                }
                                            }}
                                        >
                                            <Check className="size-4" />
                                        </Button>
                                    </SimpleTooltip>
                                )}
                            </div>
                        ) : (
                            <>
                                <Skeleton className="h-10" />
                                <Skeleton className="h-5" />
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    ) : null;
}
